import { render } from "./BecomeManagerView.vue?vue&type=template&id=6fc118c2"
import script from "./BecomeManagerView.vue?vue&type=script&lang=js"
export * from "./BecomeManagerView.vue?vue&type=script&lang=js"

import "./BecomeManagerView.vue?vue&type=style&index=0&id=6fc118c2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__